import api, { transformRequest, transformResponse } from "services/api";

export const internalMessagingApi = api.injectEndpoints({
  endpoints: (build) => ({
    sendMessageToChannel: build.mutation({
      query: (payload) => ({
        url: `/api/v1/common/internal-messaging/messages/create/`,
        method: "POST",
        body: transformRequest(payload),
      }),
      transformResponse: (response) => transformResponse(response),
    }),
    createChannel: build.mutation({
      query: (payload) => ({
        url: `/api/v1/common/internal-messaging/channels/create/`,
        method: "POST",
        body: transformRequest(payload),
      }),
      transformResponse: (response) => transformResponse(response),
    }),
    fetchSetting: build.query({
      query: () => ({
        url: "/api/v1/common/internal-messaging/setting/",
        method: "GET",
        headers: { "aktos-suppress-error": "true" },
      }),
      transformResponse: (response) => transformResponse(response),
    }),
  }),
  overrideExisting: false,
});

export const {
  useSendMessageToChannelMutation,
  useCreateChannelMutation,
  useFetchSettingQuery,
  useLazyFetchSettingQuery,
} = internalMessagingApi;
